export default __webpack_public_path__ + "assets/mobile-alert-bg.f9572ca7.png";